/**
 * Processes notification URLs by removing custom scheme prefix if present
 * @param url The URL from the notification
 * @returns Processed URL for navigation
 */
export const processNotificationUrl = (url: string): string => {
  if (!url) return '/';

  const customScheme =
    import.meta.env.VITE_PUSH_NOTIFICATION_SCHEME ||
    import.meta.env.VITE_PUSH_NOTIFICATION_SCHEME_FALLBACK ||
    'carofiadminstage';
  const schemePrefix = `${customScheme}://`;

  // Remove custom scheme prefix if present
  if (customScheme && url.startsWith(schemePrefix)) {
    return url.replace(schemePrefix, '');
  }

  return url;
};

/**
 * Determines if a URL is external (starts with http/https)
 * @param url The URL to check
 * @returns True if external, false if internal
 */
export const isExternalUrl = (url: string): boolean => {
  return url.startsWith('http://') || url.startsWith('https://');
};
